import { ChevronDefaultRight12Px, ComboboxOption, ComboboxOptionRef, StarFilled16Px } from '@galaxy-react/core';
import { forwardRef } from 'react';
import {
  SearchOriginalNameStyled,
  SearchResultCardHeaderStyled,
  SearchResultCategoryStyled,
  SearchResultDescriptionStyled,
  SearchResultReportDetailsStyled,
  SearchResultReportInfoStyled,
  SearchResultReportNameStyled,
  SearchResultWrapperStyled,
  SearchViewsAndNameStyled,
} from './search-result.styled';
import { SearchResultProps } from './search-result.types';

export const SearchResult = forwardRef<ComboboxOptionRef, SearchResultProps>(function SearchResult(
  props: SearchResultProps,
  ref,
) {
  return (
    <ComboboxOption ref={ref} {...props} text={props.text ?? ''} value={props.text ?? ''}>
      <SearchResultCardHeaderStyled
        header={
          <SearchResultWrapperStyled>
            <SearchResultCategoryStyled>{props.category}</SearchResultCategoryStyled>
            <ChevronDefaultRight12Px />
            <SearchResultReportNameStyled variant="bodyStrong">{props.text}</SearchResultReportNameStyled>
          </SearchResultWrapperStyled>
        }
        description={
          <SearchResultReportDetailsStyled>
            <SearchResultReportInfoStyled>
              {!props.originalName && props.viewedNo && (
                <span>{props.viewedNo > 0 && `${props.viewedNo} ${props.viewedNo === 1 ? ' view' : ' views'}`}</span>
              )}
              {props.originalName && props.viewedNo ? (
                <SearchViewsAndNameStyled>
                  <SearchOriginalNameStyled>{props.originalName}</SearchOriginalNameStyled>
                  {props.viewedNo > 0 && `${props.viewedNo} ${props.viewedNo === 1 ? ' view' : ' views'}`}
                </SearchViewsAndNameStyled>
              ) : null}

              <SearchResultDescriptionStyled>{props.description}</SearchResultDescriptionStyled>
            </SearchResultReportInfoStyled>
          </SearchResultReportDetailsStyled>
        }
        // action={props.isFavoured ? <StarFilled16Px color="#F69139" /> : null}
      />
      {props?.icon}
      {props.isFavoured ? <StarFilled16Px color="#F69139" /> : null}
    </ComboboxOption>
  );
});

export default SearchResult;
